<template>
  <div class="rankingTab__container">
    <!-- タブ -->
    <div class="rankingTab__tabViewContainer">
      <!-- <div v-for="data in rankingData"  -->
      <ranking-tab-view
        v-for="data in rankingData"
        :key="data.ranking_type"
        :title="title(data.ranking_type)"
        :selected="shouldShow(data.ranking_type)"
        :type="data.ranking_type"
        @selected="select"
      ></ranking-tab-view>
    </div>

    <!-- コンテンツ -->
    <div ref="tabContentContainer" class="rankingTab__contentContainer">
      <div v-for="data in rankingData" :key="data.ranking_type">
        <ranking-view
          :data="data"
          v-show="shouldShow(data.ranking_type)"
        ></ranking-view>
      </div>
    </div>
  </div>
</template>

<script>
import RankingView from '@/components/AudienceRanking/RankingView.vue'
import RankingTabView from '@/components/AudienceRanking/RankingTabView.vue'
export default {
  name: 'RankingTab',
  components: {
    RankingView,
    RankingTabView,
  },
  props: {
    rankingData: Array,
    contentHeight: Number,
  },
  data: function () {
    return {
      selected: 0,
    }
  },
  methods: {
    title: function (type) {
      switch (type) {
        case 2:
          return this.$t('audienceRankingNow')
        case 3:
          return this.$t('audienceRankingToday')
        case 4:
          return this.$t('audienceRankingMonth')
        case 5:
          return this.$t('audienceRankingTotal')
        default:
          break
      }

      return ''
    },
    shouldShow: function (type) {
      return type === this.selected
    },
    select: function (type) {
      this.selected = type
    },
  },
  mounted() {
    this.selected = Math.min(...this.rankingData.map((d) => d.ranking_type))
  },
}
</script>

<style scoped>
.rankingTab__tabViewContainer {
  height: 40px;
  display: flex;
  border-bottom: 1px solid #eeeeee;
}
</style>
